/**
 * The geometry of the guanábana mark, kept apart from the component so it can be
 * tested without a DOM and reused to generate the favicon.
 *
 * The mark is the same drawing at every size. An earlier version dropped the
 * ticks below 40px and the spine below 24px, which meant the sign-in page (40)
 * and the app shell (28) rendered visibly different illustrations.
 */

/** Drawn at every size: the ovoid, the spine, and the four ticks. */
export const LOGO_PATHS = {
  ovoid: 'M24 4c8.8 0 17 8.6 17 20 0 11.6-7.6 20-17 20S7 35.6 7 24C7 12.6 15.2 4 24 4Z',
  spine: 'M24 6v36',
  ticks: 'M15 15l3 3M33 15l-3 3M15 33l3-3M33 33l-3-3',
} as const;

export const LOGO_VIEWBOX = 48;

/** The design system specifies stroke 1.5 at 48px. */
const STROKE_AT_VIEWBOX = 1.5;

/** Below this the hairline would break up on a 1x display. */
const MIN_RENDERED_STROKE = 1.2;

/**
 * Stroke width in viewBox units. Because the viewBox is scaled to `size`, a
 * fixed width would render thinner and thinner as the mark shrinks — at 28px
 * the 1.5 stroke lands at 0.875 device px and the ticks turn to mush. Widening
 * the stroke as the mark shrinks keeps the rendered weight roughly constant,
 * which is what lets the full drawing survive at small sizes.
 */
export function logoStrokeWidth(size: number): number {
  return Math.max(STROKE_AT_VIEWBOX, (MIN_RENDERED_STROKE * LOGO_VIEWBOX) / size);
}
